import AuthProvider  from './authActions';
// import config from '../../../authConfig.json'
import currentEnvVars from '../getEnvVars';
const authProvider = new AuthProvider(currentEnvVars.msalConfig);
export default authProvider;